import { motion } from 'framer-motion';
import { ArrowUpRight, Facebook, Instagram } from 'lucide-react';
import { CONTACT } from '../data/site';

const CARDS = [
  {
    name: 'Instagram',
    handle: CONTACT.instagramHandle,
    url: CONTACT.instagram,
    icon: Instagram,
    testid: 'redes-sociais-instagram-link',
    iconClass: 'bg-gradient-to-tr from-[#FFB800] via-[#FF5500] to-[#EA1D2C]',
  },
  {
    name: 'Facebook',
    handle: CONTACT.facebookHandle,
    url: CONTACT.facebook,
    icon: Facebook,
    testid: 'redes-sociais-facebook-link',
    iconClass: 'bg-[#1877F2]',
  },
];

export default function Social() {
  return (
    <section id="redes-sociais" className="py-24 sm:py-32" data-testid="redes-sociais-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Redes sociais
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Siga o Riths
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Bastidores da cozinha, lançamentos e fotos de dar água na boca.
        </motion.p>

        <div className="mt-12 grid max-w-4xl gap-6 sm:grid-cols-2">
          {CARDS.map((card, i) => (
            <motion.a
              key={card.name}
              href={card.url}
              target="_blank"
              rel="noreferrer"
              data-testid={card.testid}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              whileHover={{ y: -6 }}
              className="group flex items-center justify-between rounded-3xl border border-white/10 bg-[#141418] p-8 transition-colors duration-300 hover:border-[#FF5500]/50"
            >
              <div className="flex items-center gap-5">
                <span
                  className={`grid h-14 w-14 shrink-0 place-items-center rounded-2xl text-white ${card.iconClass}`}
                >
                  <card.icon size={26} />
                </span>
                <div>
                  <p className="font-display text-3xl uppercase text-white">{card.name}</p>
                  <p className="text-sm text-zinc-400">{card.handle}</p>
                </div>
              </div>
              <ArrowUpRight
                size={22}
                className="shrink-0 text-zinc-500 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#FF5500]"
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
